// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { getUrlPermissionId } from '../../app/routingSelector';
import { getCurrentUserInitialisationLastViewedBoardId, isGuestSelector } from '../../user/currentUserSelector';
import { currentBoardUnconstrainedUserPermissions } from '../../utils/permissions/elementPermissionsSelector';

// Actions
import { sendAmplitudeEvent } from '../../analytics/amplitudeService';
import { convertPermissionValueToText } from '../../../common/analytics/analyticsUtils';
import { isOwner } from '../../../common/permissions/permissionUtil';

const mapStateToProps = createStructuredSelector({
    isGuest: isGuestSelector,
    initialisationLastViewedBoardId: getCurrentUserInitialisationLastViewedBoardId,
    permissions: currentBoardUnconstrainedUserPermissions,
    queryPermissionId: getUrlPermissionId,
});

let DispatchPermissionAnalyticsWhenReady = (props) => {
    const { isGuest, permissions, queryPermissionId, currentBoardId, initialisationLastViewedBoardId, setInitialised } =
        props;

    React.useEffect(() => {
        if (!permissions) return;

        const sendAnalytics =
            isGuest ||
            (queryPermissionId && initialisationLastViewedBoardId !== currentBoardId && !isOwner(permissions));

        if (sendAnalytics) {
            sendAmplitudeEvent({
                eventType: isGuest ? 'Guest arrived at public board' : 'User arrived at public board',
                eventProperties: {
                    permission: convertPermissionValueToText(permissions),
                },
            });
        }

        // As soon as we have permissions, we can stop checking
        setInitialised(true);
    });

    return null;
};

DispatchPermissionAnalyticsWhenReady.propTypes = {
    isGuest: PropTypes.bool,
    permissions: PropTypes.number,
    currentBoardId: PropTypes.string,
    queryPermissionId: PropTypes.string,
    initialisationLastViewedBoardId: PropTypes.string,
    setInitialised: PropTypes.func,
};

DispatchPermissionAnalyticsWhenReady = connect(mapStateToProps)(DispatchPermissionAnalyticsWhenReady);

const PermissionAnalyticsOnInitialisation = (props) => {
    const [initialised, setInitialised] = React.useState(false);

    // Once we've sent the analytics, never check again
    if (initialised) return null;

    return (
        <DispatchPermissionAnalyticsWhenReady currentBoardId={props.currentBoardId} setInitialised={setInitialised} />
    );
};

PermissionAnalyticsOnInitialisation.propTypes = {
    currentBoardId: PropTypes.string,
};

export default PermissionAnalyticsOnInitialisation;
